"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalysisHelperService = void 0;
class AnalysisHelperService {
    /**
     * Checks if an url is a app store url but does not check if it is valid.
     * Check if the url has apps.apple.com in it and if it does, return true.
     * @param url
     */
    static checkIfUrlIsAppStoreUrl(url) {
        if (!url.includes('apps.apple.com')) {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * Parses the app store URL and returns the app ID and country.
     * @param url
     * @returns
     */
    static parseAppStoreUrl(url) {
        // Match patterns like:
        // https://apps.apple.com/us/app/app-name/id123456789
        // https://apps.apple.com/app/app-name/id123456789
        // apps.apple.com/de/app/neotaste/id1484512399
        const regex = /apps\.apple\.com\/([a-z]{2}\/)?app\/[^/]+\/id(\d+)/;
        const match = url.match(regex);
        if (match) {
            const country = match[1]?.replace('/', '') || 'us';
            const appId = parseInt(match[2], 10);
            return { appId, country };
        }
        else {
            return null;
        }
    }
    /**
     * Checks if an url is a google play url but does not check if it is valid.
     * Check if the url has play.google.com in it and if it does, return true.
     * @param url
     */
    static checkIfUrlIsGooglePlayUrl(url) {
        if (!url.includes('play.google.com')) {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * Parses the Google Play URL and returns the app ID, lookup URL, language, and country.
     * @param url
     * @returns
     */
    static parseGooglePlayUrl(url) {
        try {
            // make it also work for urls without https://
            if (!url.startsWith('https://')) {
                url = 'https://' + url;
            }
            const parsed = new URL(url);
            const appId = parsed.searchParams.get('id');
            if (!appId)
                return null;
            const hl = (parsed.searchParams.get('hl') ?? 'en').toLowerCase();
            const gl = (parsed.searchParams.get('gl') ?? 'US').toUpperCase();
            const detailsUrl = 'https://play.google.com/store/apps/details';
            const lookupUrl = `${detailsUrl}?id=${encodeURIComponent(appId)}&hl=${encodeURIComponent(hl)}&gl=${encodeURIComponent(gl)}`;
            return { appId, lookupUrl, lang: hl, country: gl };
        }
        catch {
            return null;
        }
    }
}
exports.AnalysisHelperService = AnalysisHelperService;
